<template lang="pug">
  .scheduled-number-input
    .input-wrapper
      number-input(v-model="model", :readonly="readonly" :disabled="disabled")
      button.btn.btn-icon.ml-2(:class="{'btn-light': !localScheduledChange, 'btn-info': localScheduledChange}", v-if="!isNewItem && !readonly && !disabled", type="button", title="Schedule field update", @click="openScheduleModal")
        i.la.la-clock
    p.text-info.small.mt-1(v-if="localScheduledChange")
      | Scheduled change to '{{ localScheduledChange.new_value }}' at {{ formattedDate }}
</template>

<script>
import ScheduleFieldUpdateModal from '@/views/modals/ScheduleFieldUpdateModal.vue';
import moment from 'moment';

export default {
  name: "ScheduledInput",
  props: {
    value: [String, Number],
    entityId: Number,
    entityType: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    scheduledChange: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
   data() {
    return {
      localScheduledChange: this.scheduledChange
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    formattedDate() {
      return this.localScheduledChange && this.localScheduledChange.start_at
        ? moment(this.localScheduledChange.start_at).fromNow()
        : '';
    },
    isNewItem() {
      return !this.entityId;
    }
  },
  methods: {
    openScheduleModal() {

      const scheduledChangeId = this.localScheduledChange ? this.localScheduledChange.id : null;
      const entityId = this.entityId;
      const entityType = this.entityType;
      const fieldName = this.fieldName;
      const newValue = this.localScheduledChange ? this.localScheduledChange.new_value : this.value; 
      const startAt = this.localScheduledChange ? this.localScheduledChange.start_at : null;

      this.$modal.show(ScheduleFieldUpdateModal, {
        scheduledChangeId,
        entityId,
        entityType,
        fieldName,
        newValue,
        startAt,

        // Callback to handle updates from the modal.
        onUpdate: (updatedData) => {

          // Cancelled scheduled change
          if (updatedData.cancelled) {
            this.$set(this, 'localScheduledChange', null);
            return;
          }

          // Update existing scheduled change
          this.$set(this, 'localScheduledChange', updatedData);
        }
      }, {
        height: '60%',
      });
    },
  }
};
</script>

<style scoped>
.text-info {
  color: #007bff;
}
.scheduled-number-input {
  display: flex;
  flex-direction: column;
}

.input-wrapper {
  display: flex;
  align-items: center;
}

.input-wrapper input.form-control {
  flex: 1;
}

.btn-icon {
  padding: 6px 8px;
  border: 1px solid #ddd;
}

.btn-icon i {
  font-size: 1.2em;
}

.text-muted {
  font-size: 0.85em;
}
</style>